import Constants from '../../../utils/CommonConstants';
import InviteDialogController from './InviteDialogController';
import scopeUtils from "../../../utils/scope";
import {communicationService} from "../../../services/communicationService";
import {commandKeys} from "../../../shared/commandKeys";

export class InviteController {
    static $inject = [
        '$scope',
        '$rootScope', '$stateParams', 'CartService',
        '$mdDialog', '$state', 'AuthenticationService',
        'Session', 'LocalForageService', 'Message',
        'cartonomyConfig', 'HeapService', 'OrderSetupService', '$translate'
    ];

    constructor($scope,
                $rootScope, stateParams, cartService,
                dialogService, stateService, authenticationService,
                sessionService, localForageService, messageService,
                cartonomyConfig, HeapService, OrderSetupService, $translate) {
        this._stateParams = stateParams;
        this._cartService = cartService;
        this._dialogService = dialogService;
        this._stateService = stateService;
        this._authenticationService = authenticationService;
        this._sessionService = sessionService;
        this._messageService = messageService;
        this._cartonomyConfig = cartonomyConfig;
        //this._sessionStorageService = sessionStorage;
        this._localForageService = localForageService;
        this._rootScope = $rootScope;
        this._heapService = HeapService;
        this._orderSetupService = OrderSetupService;
        this.invitationToken = this._stateService.params;
        this._scope = $scope;
        this.$translate = $translate;

        this._rootScope.$on(Constants.Events.CANCEL_INVITATION, async () => {
            this.invitationToken = null;
            await this._localForageService.remove(Constants.SessionStorage.AwaitingInvitation);
        });

        this._rootScope.$on(Constants.Events.USER_LOGGED_IN, () => {

        });

        this._scope.$on("$destroy", async () => {
            this._sessionService.setCartReference(null);
            await this._cartService.getCart();

            let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG;
            await this._stateService.go(stateToGo);
            scopeUtils.apply(this._scope);
        });
    }

    async $onInit() {
        try {
            this.invitationToken = this._stateService.params;
            await this._authenticationService.waitForLogin(true);
            const cart = await this._cartService.getCart();
            this._orderSetupService.invitationPromise = this._safeAccept(cart);

        } catch (error) {
            this._showInviteError();
            //await this._handleAcceptError(error);
        }
    }

    async _acceptInvite(forceInvite, resolve) {
        try {
            await this._localForageService.store(Constants.SessionStorage.AwaitingInvitation, JSON.stringify(this.invitationToken));

            const response = await this._cartService.acceptInvite(this._stateParams.participantToken, forceInvite || false);
            await this._heapService.track('Invite-Accepted', {token: this._stateParams.participantToken});

            // if (!response.alreadyJoined) {
            //     await this._showInviteWelcome(response);
            // }

            // make sure cart is loaded before going to chat;
            await this._sessionService.setCartReference(null, false);

            await  this._rootScope.$broadcast(Constants.Events.INVITATION_ACCEPTED);

            let cart = await this._cartService.getCart(response.cartId, false);
            await this._localForageService.remove(Constants.SessionStorage.AwaitingInvitation);
            await this._localForageService.remove(Constants.SessionStorage.InvitationUserInvalid);

            //let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CART;

            if (!this._sessionService.isTryingToLogIn) {
                await this._orderSetupService.showInvitePreview();
            }
            await this._stateService.go(Constants.RoutingStates.CHAT);
            let resp = await communicationService.requestToParent(commandKeys.invitationAccepted, {cart: cart});
            if(!resp.success) {
                this._messageService.showErrorPopup(this.$translate.instant('client.order.group_restrict_add'));
            }
        } catch (e) {
            await this._handleAcceptError(e, forceInvite);
        }

    }

    async _handleLoginRequest(response) {
        try {
            if(this._sessionService.isTryingToLogIn) {
                return;
            }
            if (!(await this._sessionService.loggedIn())) {
                this._sessionService.isTryingToLogIn = true;
                const invitedCart = await this._cartService.getCartByInvitationCode(this._stateParams.participantToken);
                await this._authenticationService.showLoginDialog(
                    response.data && response.data.parameters && response.data.parameters.prefillEmail,
                    response.data && response.data.parameters && response.data.parameters.needSignUp ? 'signup' : null,
                    false,
                    invitedCart
                );
            }

            // check again
            if(await this._sessionService.loggedIn()) {
                await this._acceptInvite(null);
                this._sessionService.isTryingToLogIn = false;
                return false;
            }
        } catch (error) {
            if (error && error.cancel) {
                let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG;
                this._stateService.go(stateToGo);
                return false;
            }
            // throw error;
        }
        return true;
    }

    async _handleAcceptError(response, forceInvite) {
        if (response.status === 401 && !(await this._sessionService.loggedIn())) {
            try {
                await this._handleLoginRequest(response);
            } catch (e) {
            }
            return null;
        }

        let isInvitationNotForCurrentUser = await this._localForageService.retrieve(Constants.SessionStorage.InvitationUserInvalid);

        // the invitation is not for logged in user
        if (response.status === 403 && response.data.exceptionType === 'UnauthorizedGroupOrderInvitationException') {
            if (isInvitationNotForCurrentUser) {
                await this._messageService.showMessagePopup(
                    this.$translate.instant('client.user.email_different', { email: response.data.parameters.prefillEmail }),
                    this.$translate.instant('client.order.joining'));
                //
                // let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG;
                // this._stateService.go(stateToGo);
                // return null;
            }

            // log out first;
            await this._authenticationService.logout();

            if (await this._localForageService.exists(Constants.SessionStorage.InvitationUserInvalid)) {
                await this._localForageService.store(Constants.SessionStorage.InvitationUserInvalid, true);
            }

            await this._acceptInvite();

            return null;
        }

        if (response.status === 403 && response.data.exceptionType === 'JoiningCartHasBeenClosedException') {
            await this._localForageService.remove(Constants.SessionStorage.AwaitingInvitation);
            await this._localForageService.remove(Constants.SessionStorage.InvitationUserInvalid);

            this._sessionService.setCartReference(null, false);
            await this._cartService.getCart();
            this._rootScope.$broadcast(Constants.Events.INVITATION_FAILED_DUE_TO_CART_CLOSED);

            await this._messageService.showMessagePopup(response.data.message);

            if (!(await this._sessionService.loggedIn())) {
                await this._authenticationService.showLoginDialog('', 'facade', true);
            }

            let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG;

            await this._stateService.go(stateToGo);
            return null;
        }

        if(response.status === 403 && response.data.exceptionType === 'JoiningOwnCartException'){
            await this._messageService.showErrorPopupForResponse(response);
            let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG;
            this._stateService.go(stateToGo);
            return null;
        }

        if (response.status === 409 && response.data.exceptionType === 'CartPaidMergeException' && !forceInvite) {
            try {
                await this._showInviteConfirmLeavePaidCart();
                this._rootScope.forceInvite = true;
                await this._acceptInvite(true);
            } catch (error) {
                this._sessionService.setCartReference(null, false);
                const isGroupOrder = await this._cartService.isGroupOrder();
                const message = `${this.$translate.instant('client.order.group_order_declined')} ${isGroupOrder? this.$translate.instant('client.order.group_order_taken'): this.$translate.instant('client.order.group_order_prompted') }`;
                await this._messageService.showMessagePopup(message);

                let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG;
                this._stateService.go(stateToGo);
            }
            return null;
        }

        if (response.status === 409 && !forceInvite) {
            try {
                await this._showInviteConfirm();
                this._rootScope.forceInvite = true;
                await this._acceptInvite(true);
            } catch (error) {
                this._sessionService.setCartReference(null, false);
                const isGroupOrder = await this._cartService.isGroupOrder();
                const message = `${this.$translate.instant('client.order.group_order_declined')} ${isGroupOrder? this.$translate.instant('client.order.group_order_taken'): this.$translate.instant('client.order.group_order_prompted') }`;
                await this._messageService.showMessagePopup(message);

                let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG;
                this._stateService.go(stateToGo);
            }
            return null;
        }

        if (this._messageService.isErrorResponse(response)) {
            await this._messageService.showErrorPopupForResponse(response);
            let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CHAT : Constants.RoutingStates.CATALOG;
            this._stateService.go(stateToGo);
            return null;
        }

        // this._showInviteError();
    }

    _safeAccept(cart) {
       return new Promise(async (resolve) => {
            if (await this._sessionService.loggedIn()) {
                await this._acceptInvite(false);
            } else  if (await this._cartService.isGroupOrder(cart)) {
                let confirmed = await this._messageService.showQuestionPopup(this.$translate.instant('client.order.user_removed'), this.$translate.instant('client.order.joining'), this.$translate.instant(client.yes), this.$translate.instant(client.no), 'md-warn');
                if (confirmed) {
                    await this._acceptInvite(false);
                }
            } else if (!cart.items.length) {
                await this._cartService.deleteCart();
                await this._acceptInvite(false);
            } else {
                let confirmed = await this._messageService.showQuestionPopup(this.$translate.instant('client.order.item_removed'), this.$translate.instant('client.order.joining'), this.$translate.instant(client.yes), this.$translate.instant(client.no), 'md-warn');
                if (confirmed) {
                    await this._cartService.deleteCart();
                    await this._acceptInvite(false);
                }
            }
           resolve();
        });
    }

    _showInviteWelcome(response) {

        // if (response.alreadyJoined) {
        //     this._authenticationService.loginWithInviteToken(response);
        //     this._stateService.go(Constants.RoutingStates.CATALOG);
        // }


        return this._dialogService.show({
            controller: InviteDialogController(response),
            templateUrl: "modules/order/views/inviteWelcome.html",
            clickOutsideToClose: false
        });
    }

    _showInviteConfirm() {
        // [CW-2417]
        this._rootScope.storeWindowTitle = "client.order.joining_group";
        return this._dialogService.show({
            controller: ['$scope', '$mdDialog', (scope, dialogService) => {
                scope.accept = () => {
                    dialogService.hide();
                    this._rootScope.storeWindowTitle = null;
                };
                scope.cancel = () => {
                    dialogService.cancel();
                    this._rootScope.storeWindowTitle = null;
                };
            }],
            templateUrl: "modules/order/views/inviteConfirm.html",
            clickOutsideToClose: false
        });
    }

    _showInviteConfirmLeavePaidCart() {
        return this._dialogService.show({
            controller: ['$scope', '$mdDialog', (scope, dialogService) => {
                scope.accept = () => {
                    dialogService.hide();
                };
                scope.cancel = () => {
                    dialogService.cancel();
                };
            }],
            template: require('../views/inviteConfirmLeavePaidCart.pug'),
            clickOutsideToClose: false
        });
    }

    _showInviteError() {
        return this._dialogService.show({
            controller: ['$scope', '$mdDialog', (scope, dialogService) => {

                scope.ok = () => {
                    dialogService.hide();
                    let stateToGo = this._cartonomyConfig.externalStoreMode ? Constants.RoutingStates.CART : Constants.RoutingStates.CATALOG;
                    this._stateService.go(stateToGo);
                };
            }],
            templateUrl: "modules/order/views/inviteFailed.html",
            clickOutsideToClose: false
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/order/controllers/InviteController.js